import React from 'react';
import { withRouter } from 'react-router-dom';
import { Button } from 'antd';
const ManageFooter = (props) => {
  const isDarkTheme = localStorage.getItem('theme') == 'dark' ? true : false;

  const showNotificationsAndDefaultsButtons =
    props.pageViewType === 'requests' || props.pageViewType === 'issues'
      ? true
      : false;
  return (
    <div style={{ paddingTop: '16px' }}>
      <div
        style={{
          borderBottom: `${
            isDarkTheme
              ? '1px solid rgba(255, 255, 255, 0.1)'
              : '1px solid rgba(0, 0, 0, 0.06)'
          }`,
        }}
        className='apphome_borders'
      ></div>
      <div style={{ paddingTop: '16px' }}>
        <div style={{ display: 'flex', gap: '8px' }}>
          {showNotificationsAndDefaultsButtons && (
            <>
              <Button className='apphome-display-btn'>
                Personal Notifications
              </Button>
              <Button className='apphome-display-btn'>Personal Defaults</Button>
            </>
          )}
          <Button className='apphome-display-btn'>Go to webapp</Button>
          {!showNotificationsAndDefaultsButtons && (
            <>
              <Button className='apphome-display-btn'>
                Help &#38; feedback
              </Button>
              <Button className='apphome-display-btn'>
                Book a personalized demo
              </Button>
            </>
          )}
        </div>
        {showNotificationsAndDefaultsButtons && (
          <div style={{ paddingTop: '8px' }}>
            <Button
              style={{ marginRight: '8px' }}
              className='apphome-display-btn'
            >
              Help &#38; feedback
            </Button>
            <Button className='apphome-display-btn'>
              Book a personalized demo
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default withRouter(ManageFooter);
